<div class="line-card">  
    <div class="card-header">
        <div class="card-title">
          <strong>Parts Market Activity</strong>
        </div>
      </div>
    <!-- Chart Container -->
    <canvas id="partSalesChart"></canvas>
  </div>
  